/* Eos showroom landing page – scroller arrows + gallery lightbox. Safe to load more than once. */
(function () {
  if (window.EosShowroomInit) return;
  window.EosShowroomInit = true;

  function initScrollers(root) {
    root.querySelectorAll('[data-eos-scroller]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '');
      var track = wrap.querySelector('[data-eos-track]');
      var prev = wrap.querySelector('[data-eos-prev]');
      var next = wrap.querySelector('[data-eos-next]');
      if (!track) return;
      function step() { return Math.max(track.clientWidth * 0.8, 200); }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        var nav = wrap.querySelector('.eos-sl-nav');
        if (nav) nav.style.visibility = max <= 0 ? 'hidden' : '';
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initLightbox(root) {
    root.querySelectorAll('[data-eos-lightbox]:not([data-ready])').forEach(function (gallery) {
      gallery.setAttribute('data-ready', '');
      var dialog = gallery.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var img = dialog.querySelector('img');
      var cap = dialog.querySelector('p');
      gallery.querySelectorAll('[data-full]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          img.src = btn.getAttribute('data-full');
          img.alt = btn.getAttribute('data-alt') || '';
          cap.textContent = btn.getAttribute('data-caption') || '';
          dialog.showModal();
        });
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.hasAttribute('data-close')) dialog.close(); });
    });
  }

  function highlightToday(root) {
    var day = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'][new Date().getDay()];
    root.querySelectorAll('.eos-sl-hours tr[data-day="' + day + '"]').forEach(function (tr) { tr.classList.add('is-today'); });
  }

  function init(root) { initScrollers(root); initLightbox(root); highlightToday(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Re-run when sections are edited in the Shopify theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();